
import { createSlice } from '@reduxjs/toolkit'

import { planningShiftTablesAdapter } from '../adapters/planningShiftTablesAdapter'

export const initialPlanningShiftTableState = planningShiftTablesAdapter.getInitialState()

export const planningShiftTablesSlice = createSlice({
  name: 'planningShiftTables',
  initialState: initialPlanningShiftTableState,
  reducers: {
    upsertMultiplePlanningShiftTables: (state, action) => {
      planningShiftTablesAdapter.upsertMany(state, action.payload)
    },
    upsertOnePlanningShiftTable: (state, action) => {
      planningShiftTablesAdapter.upsertOne(state, action.payload)
    },
    setPlanningShiftTableLoading: (state, action) => {
      const { id, isLoading } = action.payload
      const existingShiftTable = state.entities[id]
      
      if (existingShiftTable) {
        existingShiftTable.isLoading = isLoading
      }
    },
  },
})

export const { upsertMultiplePlanningShiftTables, upsertOnePlanningShiftTable, setPlanningShiftTableLoading } = planningShiftTablesSlice.actions
